import { useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { EMAIL_CAMPAIGN } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { useEditorActions } from '../../hooks/useEditorActions';
import { useFieldConditionChange } from '../../hooks/useFieldConditionChange';
import { useMarketingEmailFilter } from '../../hooks/useMarketingEmailFilter';
import ConditionError from '../common/ConditionError';
import EditorConditionInputs from './EditorConditionInputs';
import EditorConditionRefinements from './EditorConditionRefinements';
import EditorConditionRefinementsContainer from './EditorConditionRefinementsContainer';
import EditorRelatedConditionsGroupContainer from './EditorRelatedConditionsGroupContainer';
import EditorRelatedConditionsRefineButton from './EditorRelatedConditionsRefineButton';
import EditorConditionAsset from './EditorConditionAsset';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorMarketingEmailRelatedConditionsGroup = props => {
  var _condition$field;
  const {
    props: {
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    condition,
    conditionPath,
    dataSeleniumInfo,
    inputUse
  } = props;
  const {
    onRefineFilter,
    onConditionDelete
  } = useEditorActions();
  const {
    onFieldConditionValueChange,
    onFieldConditionOperatorChange
  } = useFieldConditionChange(EMAIL_CAMPAIGN, conditionPath, condition);
  const {
    statusCondition,
    dateRefinementCondition,
    refinementConditionsEmptyValue,
    onStatusChange
  } = useMarketingEmailFilter(condition, onFieldConditionValueChange);
  const hasInPlaceRefinementSelection = !!useOnePanel;

  //@ts-expect-error `userHasNoAccess` does not exist on `DSFieldRecordInstance`
  const userHasNoAccess = (_condition$field = condition.field) === null || _condition$field === void 0 ? void 0 : _condition$field.userHasNoAccess;
  const heading = /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(EditorConditionInputs, {
      condition: statusCondition,
      dataSeleniumInfo: dataSeleniumInfo,
      disabled: userHasNoAccess,
      filterFamily: EMAIL_CAMPAIGN,
      header: /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "200",
        as: "div",
        children: /*#__PURE__*/_jsx(EditorConditionAsset, {
          condition: condition,
          filterFamily: EMAIL_CAMPAIGN,
          inputUse: inputUse
        })
      }),
      inputUse: inputUse,
      onConditionOperatorChange: onFieldConditionOperatorChange,
      onConditionValueChange: onStatusChange
    }, conditionPath === null || conditionPath === void 0 ? void 0 : conditionPath.join('.')), /*#__PURE__*/_jsx(ConditionError, {
      condition: condition
    }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
      condition: condition
    }), !hasInPlaceRefinementSelection && /*#__PURE__*/_jsx(EditorRelatedConditionsRefineButton, {
      dataSeleniumInfo: dataSeleniumInfo,
      disabled: userHasNoAccess,
      onClick: () => onRefineFilter(EMAIL_CAMPAIGN, conditionPath)
    }), hasInPlaceRefinementSelection && !userHasNoAccess && /*#__PURE__*/_jsx(EditorConditionRefinementsContainer, {
      inputUse: inputUse,
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: EMAIL_CAMPAIGN,
      onConditionChange: onFieldConditionValueChange,
      emptyRefinementConditions: refinementConditionsEmptyValue
    })]
  });
  return hasInPlaceRefinementSelection ? /*#__PURE__*/_jsx(EditorRelatedConditionsGroupContainer, {
    condition: condition,
    conditionPath: conditionPath,
    dataSeleniumInfo: dataSeleniumInfo,
    filterFamily: EMAIL_CAMPAIGN,
    heading: heading,
    onGroupDelete: () => onConditionDelete(conditionPath)
  }) : /*#__PURE__*/_jsx(EditorRelatedConditionsGroupContainer, {
    condition: condition,
    conditionPath: conditionPath,
    dataSeleniumInfo: dataSeleniumInfo,
    filterFamily: EMAIL_CAMPAIGN,
    heading: heading,
    onGroupDelete: () => onConditionDelete(conditionPath),
    children: /*#__PURE__*/_jsx(EditorConditionRefinements, {
      inputUse: inputUse,
      condition: condition,
      filterFamily: EMAIL_CAMPAIGN,
      onConditionChange: onFieldConditionValueChange,
      dateRefinement: dateRefinementCondition
    })
  });
};
export default EditorMarketingEmailRelatedConditionsGroup;